import Collapse from "react-bootstrap/Collapse";
import {useTranslation} from "react-i18next";
import {Button} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useEffect, useState} from "react";
import Form from "react-bootstrap/Form";
// -
import WasteTypesSelect from "site-apps/assets/components/WasteTypesSelect";
import DownloadTypesSelect from "site-apps/assets/components/DownloadTypesSelect";
import SearchSelect from "components/selects/SearchSelect";

const BoxFilterContainers = ({filters, show, filtersParams}) => {
    const {t: _Tt} = useTranslation("tables");
    const {t: _Tc} = useTranslation("choices");
    const [waste, setWaste] = useState("");
    const [download, setDownload] = useState("");
    const [groups, setGroups] = useState([]);
    const [routes, setRoutes] = useState([]);

    useEffect(() => {
        if (filtersParams?.groups) {
            setGroups(
                filtersParams.groups.map((item) => ({
                    value: item.id,
                    label: item.name,
                })),
            );
        }
        if (filtersParams?.routes) {
            setRoutes(
                filtersParams.routes.map((item) => ({
                    value: item.id,
                    label: item.name,
                })),
            );
        }
    }, [filtersParams]);

    function onChangeSelect(e, actionMeta = null) {
        let name, value;
        if (actionMeta) {
            switch (actionMeta.action) {
                case "select-option":
                    name = actionMeta.name;
                    value = e.value;
                    break;
                case "clear":
                    name = actionMeta.name;
                    value = "";
                    break;
                default:
                    name = actionMeta.name;
                    value = "";
            }
        } else {
            name = e.target.name;
            value = e.target.value;
        }

        let named = name.replace("filter-", "");
        if (value) {
            filters.chosen[named] = value;
        } else {
            delete filters.chosen[named];
        }
        filters.filter();
        switch (named) {
            case "waste_type":
                setWaste(value);
                break;
            case "download_type":
                setDownload(value);
                break;
            default:
                break;
        }
    }

    function clearFilters() {
        filters.chosen = {};
        setWaste("");
        setDownload("");
        filters.filter();
    }

    return (
        <Collapse in={show}>
            <div id="filter-collapse" className="p-3">
                <div className="row">
                    <Button type="button" variant="link" onClick={clearFilters} className="col-1" title="Quitar filtros">
                        <FontAwesomeIcon icon="filter-circle-xmark" />
                    </Button>
                    <div className="col" style={{maxWidth: "160px"}}>
                        <label
                            style={{
                                width: "100%",
                                fontWeight: "bold",
                                textAlign: "center",
                            }}>
                            {_Tt("containers.download_type")}
                        </label>
                        <DownloadTypesSelect multiple={false} prefix="filter-" value={download} onChange={onChangeSelect} />
                    </div>
                    <div className="col" style={{maxWidth: "150px"}}>
                        <label
                            style={{
                                width: "100%",
                                fontWeight: "bold",
                                textAlign: "center",
                            }}>
                            {_Tt("containers.waste_type")}
                        </label>
                        <WasteTypesSelect multiple={false} prefix="filter-" value={waste} onChange={onChangeSelect} />
                    </div>
                    <div className="col" style={{maxWidth: "140px"}}>
                        <label
                            style={{
                                width: "100%",
                                fontWeight: "bold",
                                textAlign: "center",
                            }}>
                            {_Tt("common.status")}
                        </label>
                        <Form.Select aria-label="Selector de estado" name="filter-status" onChange={onChangeSelect}>
                            <option value="">{_Tc("labels.all")}</option>
                            <option value="ac">{_Tc("containerStatus.ac")}</option>
                            <option value="rp">{_Tc("containerStatus.rp")}</option>
                            <option value="rs">{_Tc("containerStatus.rs")}</option>
                            <option value="ds">{_Tc("containerStatus.ds")}</option>
                            <option value="cb">{_Tc("containerStatus.cb")}</option>
                            <option value="ns">{_Tc("containerStatus.ns")}</option>
                        </Form.Select>
                    </div>
                    <div className="col-2">
                        <label
                            style={{
                                width: "100%",
                                fontWeight: "bold",
                                textAlign: "center",
                            }}>
                            {_Tt("containers.group")}
                        </label>
                        <SearchSelect
                            options={groups.length ? [{value: "", label: _Tc("labels.all")}, ...groups] : []}
                            name="filter-group"
                            placeholder={_Tc("devices.all")}
                            onChange={onChangeSelect}
                            isClearable
                            isMulti={false}
                        />
                    </div>
                    <div className="col-2">
                        <label
                            style={{
                                width: "100%",
                                fontWeight: "bold",
                                textAlign: "center",
                            }}>
                            {_Tt("common.route")}
                        </label>
                        <SearchSelect
                            options={groups.length ? [{value: "", label: _Tc("labels.all")}, ...routes] : []}
                            name="filter-route"
                            placeholder={_Tc("devices.all")}
                            onChange={onChangeSelect}
                            isClearable
                            isMulti={false}
                        />
                    </div>
                </div>
            </div>
        </Collapse>
    );
};

export default BoxFilterContainers;
